import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  FormControlLabel,
  Checkbox,
  Grid,
  Snackbar,
  Alert,
  CircularProgress,
  TextField,
} from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";
import logo from "./../../../img/logore.png";
import { useDispatch, useSelector } from "react-redux";
import {
  BaseUrlEncuesta,
  BaseUrlQuejas,
} from "../../../services/axios/AxiosEndpoints";
import { setEstatusEncuesta } from "../../../reducers/users/userSlices";
import DOMPurify from "dompurify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "2px solid #000",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

const FormEncuesta = ({ openEncuesta, handleCloseEncuesta }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [statusSelectedOption, setStatuSelectedOption] = useState();
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [guardarQuejas, setGuardarQuejas] = useState([]);
  const [errorGuardarQuejas, setErrorGuardarQuejas] = useState([]);
  const [statusguardarRegistro, setStatuGuardarQuejas] = useState();

  const [isFetching, setIsFetching] = useState(false);

  const [detalle, setDetalle] = useState("");
  const [telefono, setTelefono] = useState("");

  const { codPss } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  /* ---------------------------- ---------------------------- */

  const validate = () => {
    let errors = {};

    if (!detalle) {
      errors.detalle = "Este campo no puede estar vacío";
    }

    if (!telefono) {
      errors.telefono = "Este campo no puede estar vacío";
    }

    return errors;
  };

  /* ---------------------------- ---------------------------- */

  const handleSnackbarClose = () => setSnackbarOpen(false);

  /* ---------------------------- ---------------------------- */

  const handleChange = (event) => {
    setSelectedOption(event.target.name);
  };

  /* ---------------------------- ---------------------------- */

  const HandleChangeTelefono = (event) => {
    // Obtén el valor actual del campo de identificación
    let { value } = event.target;

    // Elimina los guiones existentes y cualquier carácter que no sea un número
    value = value.replace(/[^0-9]/g, "");

    // Agrega guiones en las posiciones correspondientes
    if (value.length > 3 && value.length <= 6) {
      value = `${value.slice(0, 3)}-${value.slice(3)}`;
    } else if (value.length > 6 && value.length <= 10) {
      value = `${value.slice(0, 3)}-${value.slice(3, 6)}-${value.slice(6)}`;
    }

    // Actualiza el estado con el nuevo valor formateado
    setTelefono(value);
  };

  /* ---------------------------- ---------------------------- */

  const HandleChangeDetalle = (e) => {
    const inputValue = e.target.value;
    setDetalle(inputValue);
  };

  /* ---------------------------- ---------------------------- */

  const handleSubmitEnviarRespuesta = async (e) => {
    e.preventDefault();

    if (!selectedOption) {
      setSnackbarMessage("Debes seleccionar una opción.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    if (selectedOption === "2") {
      if (telefono !== "" && detalle !== "") {
        setLoading(true);

        // Enviar el valor seleccionado al endpoint
        await axios({
          url: `${BaseUrlEncuesta}/RegistrarSatisfaccion`,
          method: "POST",
          headers: {
            Accept: "Application/json, text/plain, */*",
            "Content-Type": "Application/json",
          },
          params: {
            codpss: codPss,
            satisfaccion: selectedOption,
          },
        })
          .then((response) => {
            if (response.status === 200) {
              dispatch(
                setEstatusEncuesta({
                  encuestar: "0",
                })
              );
              setStatuSelectedOption(response.status);
              setSnackbarMessage("¡Respuesta enviada con éxito!");
              setSnackbarSeverity("success");
            }
          })
          .catch(function (error) {
            if (error.response) {
              if (error.response.status === 400) {
                setSnackbarMessage("Hubo un error al enviar tu respuesta.");
                setSnackbarSeverity("error");
              } else if (error.response.status === 500) {
                setSnackbarMessage("Hubo un error al enviar tu respuesta.");
                setSnackbarSeverity("error");
              }

              setSnackbarMessage("Hubo un error al enviar tu respuesta.");
              setSnackbarSeverity("error");

              Swal.fire({
                title: "",
                text: error.response.data,
                icon: "warning",
                confirmButtonText: "Ok",
              });
            } else if (error.request) {
              Swal.fire({
                title: "",
                text: error.request,
                icon: "warning",
                confirmButtonText: "Ok",
              });
            }
          })
          .finally(() => {
            setLoading(false);
            setSnackbarOpen(true);
            handleCloseEncuesta();
          });
      }
    } else {
      setLoading(true);

      // Enviar el valor seleccionado al endpoint
      await axios({
        url: `${BaseUrlEncuesta}/RegistrarSatisfaccion`,
        method: "POST",
        headers: {
          Accept: "Application/json, text/plain, */*",
          "Content-Type": "Application/json",
        },
        params: {
          codpss: codPss,
          satisfaccion: selectedOption,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            dispatch(
              setEstatusEncuesta({
                encuestar: "0",
              })
            );
            setStatuSelectedOption(response.status);
            setSnackbarMessage("¡Respuesta enviada con éxito!");
            setSnackbarSeverity("success");
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 400) {
              setSnackbarMessage("Hubo un error al enviar tu respuesta.");
              setSnackbarSeverity("error");
            } else if (error.response.status === 500) {
              setSnackbarMessage("Hubo un error al enviar tu respuesta.");
              setSnackbarSeverity("error");
            }

            setSnackbarMessage("Hubo un error al enviar tu respuesta.");
            setSnackbarSeverity("error");

            Swal.fire({
              title: "",
              text: error.response.data,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          } else if (error.request) {
            Swal.fire({
              title: "",
              text: error.request,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          }
        })
        .finally(() => {
          setLoading(false);
          setSnackbarOpen(true);
          handleCloseEncuesta();
        });
    }
  };

  /* ---------------------------- ---------------------------- */

  useEffect(() => {
    if (telefono !== "" && detalle !== "" && statusSelectedOption === 200) {
      setIsFetching(true);

      const sanitizedDetalle = DOMPurify.sanitize(detalle);
      const sanitizedContacto = DOMPurify.sanitize(telefono);

      axios({
        url: `${BaseUrlQuejas}/enviarQueja`,
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
        data: {
          CodAfi: codPss,
          Detalle: sanitizedDetalle,
          Contacto: sanitizedContacto,
          anexos: "",
          Canal: 2,
        },
      })
        .then((response) => {
          if (response.status === 200) {
            setGuardarQuejas(response.data);
            setStatuGuardarQuejas(response.status);
            Swal.fire({
              title: "",
              text: "¡Respuesta enviada con éxito!",
              icon: "success",
              confirmButtonText: "Ok",
            });
            setTimeout(() => {
              window.location.reload();
            }, 3000);
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 400) {
              setErrorGuardarQuejas("El recurso no fue encontrado.");
            } else if (error.response.status === 500) {
              setErrorGuardarQuejas("Ha ocurrido un error en el servidor");
            }

            setErrorGuardarQuejas(error.response.data);
            Swal.fire({
              title: "",
              text: error.response.data,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          } else if (error.request) {
            Swal.fire({
              title: "",
              text: error.request,
              icon: "warning",
              confirmButtonText: "Ok",
            });
          }
        })
        .finally(() => setIsFetching(false));
    }
  }, [codPss, detalle, telefono, statusSelectedOption]);

  /* ---------------------------- ---------------------------- */

  return (
    <>
      <Modal
        open={openEncuesta}
        onClose={handleCloseEncuesta}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        closeAfterTransition
      >
        <Box sx={style}>
          <Box>
            <img
              src={logo}
              alt="logo"
              style={{
                width: "15%",
                height: "auto", // Reemplaza con la URL de tu imagen de fondo
                marginTop: "0px",
                marginLeft: "0px",
                position: "absolute",
              }}
            />
          </Box>

          <Typography
            id="modal-title"
            variant="h5"
            component="h2"
            fontWeight="bold"
            marginBottom="40px"
            align="center"
            gutterBottom
          >
            Ayúdanos a mejorar
          </Typography>

          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            align="Left"
            marginBottom="20px"
            gutterBottom
          >
            ¿Según su experiencia con la plataforma Web, como la clasificas?
          </Typography>

          <Grid
            container
            spacing={0}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedOption === "1"}
                    onChange={handleChange}
                    name="1"
                    sx={{ color: "#0B192C" }}
                  />
                }
                label="Excelente"
              />
            </Grid>

            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectedOption === "2"}
                    onChange={handleChange}
                    name="2"
                    sx={{ color: "#0B192C" }}
                  />
                }
                label="Puede mejorar"
              />
            </Grid>

            {selectedOption === "2" ? (
              <>
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      marginTop: {
                        xs: "10px",
                        sm: "10px",
                        md: "10px",
                        lg: "10px",
                      },
                      marginBottom: {
                        xs: "10px",
                        sm: "10px",
                        md: "0px",
                        lg: "0px",
                      },
                      fontWeight: "bold",
                      textAlign: {
                        xs: "center",
                        sm: "center",
                        md: "left",
                        lg: "left",
                      },
                    }}
                  >
                    Contacto
                  </Typography>

                  <TextField
                    size="small"
                    placeholder="Número de Teléfono"
                    autoComplete="telefono"
                    id="telefono"
                    name="telefono"
                    value={telefono}
                    onChange={HandleChangeTelefono}
                    inputProps={{
                      maxLength: 12,
                    }}
                    error={validate().telefono}
                    helperText={validate().telefono}
                    sx={{
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "90%",
                        lg: "90%",
                      },
                    }}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography
                    sx={{
                      marginTop: {
                        xs: "10px",
                        sm: "10px",
                        md: "10px",
                        lg: "10px",
                      },
                      marginBottom: {
                        xs: "0px",
                        sm: "0px",
                        md: "0px",
                        lg: "0px",
                      },
                      fontWeight: "bold",
                      textAlign: {
                        xs: "center",
                        sm: "center",
                        md: "left",
                        lg: "left",
                      },
                    }}
                  >
                    Detalle
                  </Typography>
                  <TextField
                    sx={{
                      mt: 0,
                      mb: 0,
                      mx: 0,
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "90%",
                        lg: "90%",
                      },
                      height: "auto",
                    }}
                    placeholder="Describa su queja o sugerencia"
                    autoComplete="detalle"
                    id="detalle"
                    name="detalle"
                    size="small"
                    multiline
                    rows={6}
                    value={detalle}
                    onChange={HandleChangeDetalle}
                    error={validate().detalle}
                    helperText={validate().detalle}
                  />
                </Grid>
              </>
            ) : (
              <></>
            )}

            <Grid
              item
              display="flex"
              justifyContent="center"
              alignContent="center"
              xs={12}
            >
              <Button
                onClick={handleSubmitEnviarRespuesta}
                variant="contained"
                color="success"
                fullWidth
                disabled={!selectedOption || loading}
                sx={{
                  mt: 5,
                  width: "150px",
                  background: "#0B192C",
                  color: "white",
                  borderRadius: "8px",
                  boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
                }}
              >
                {loading ? <CircularProgress size={24} /> : "Enviar"}

                {isFetching && <CircularProgress size={24} />}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      {/* Snackbar para notificaciones */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default FormEncuesta;
